import { createFileRoute } from '@tanstack/react-router'

import { CarrierProductPage } from '#/modules/carriers/carrier-product-page'

export const Route = createFileRoute('/_shell/carriers/')({
  component: CarrierProductPage,
})
